import { Redirect, Route, useLocation } from 'react-router-dom';
import type { ElementType } from 'react';
import { useEffect } from 'react';
import { useAuth } from '@eti/authentication';
import { routes } from '../../../constants/routesAndApisConstants';
import { usePageViewDataLayerEvent } from '../../data-layer/dataLayer';
import { useGA4PageViewEvent } from '../../data-layer/ecommerce/custom-hooks/useGA4PageViewEvent';

interface LoginRouteProps {
  component: ElementType;
  isRyanairOrder?: boolean;
  redirectTo: string;
  setIsMenuVisible: (pathname: { type: string }) => void;
  shouldSkipDataLayerEvent?: boolean;
  exact?: boolean;
  path: string;
}

const LoginRoute = ({
  component: Component,
  redirectTo,
  isRyanairOrder,
  setIsMenuVisible,
  shouldSkipDataLayerEvent,
  exact,
  path,
}: LoginRouteProps) => {
  const location = useLocation();
  const { user } = useAuth();
  usePageViewDataLayerEvent(undefined, shouldSkipDataLayerEvent);
  const isPostbookingLogin = path === routes.POSTBOOKING_AUTHENTICATION;
  const getLoginPageView = () => {
    if (isRyanairOrder) {
      return {
        responsive_url: routes.RYANAIR_ORDER_AUTHENTICATION,
        page_type: 'Login',
        page_type_detailed: 'Ryanair',
      };
    }
    if (isPostbookingLogin) {
      return {
        responsive_url: routes.POSTBOOKING_AUTHENTICATION,
        page_type: 'Login',
        page_type_detailed: 'Postbooking',
      };
    }
    return {
      responsive_url: routes.ORDER_AUTHENTICATION,
      page_type: 'Login',
      page_type_detailed: 'My Bookings',
    };
  };
  useGA4PageViewEvent(getLoginPageView(), !user);
  useEffect(() => {
    setIsMenuVisible({ type: location.pathname });
  }, [setIsMenuVisible, location.pathname]);

  return (
    <Route
      exact={exact}
      path={path}
      render={() =>
        !user ? (
          <Component isRyanairOrder={isRyanairOrder} />
        ) : (
          <Redirect to={{ pathname: user.sessionOrderNumber ? redirectTo : routes.ORDER_LIST }} />
        )
      }
    />
  );
};

export default LoginRoute;
